import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../components/wrapper';
import './styles.css';
import RelatedVideo from "../related-video";
import BodyControl from "../../components/body";
import {IS_IOS, WINDOW, DOCUMENT} from "../../constants/environment";
import YoutubePlayer from "../../components/youtube-player";
// -----------------------------------------------
/**
 * `div.Video__wysiwyg-[pc|mb]` tag 生成します
 * @param {?string} description 説明文(HTML)
 * @param {?string} [suffix=''] [pc|mb] 識別子
 * @param {string} [baseClass=Video__wysiwyg] base class name
 * @returns {?ReactElement} `div.Video__wysiwyg-[pc|mb]` tag
 * @constructor
 */
const WysiwygTag = ({ description, suffix, baseClass }) => {
  if (!description) {
    return null;
  }
  return (
    <div
      className={`${baseClass}${suffix ? '-': ''}${suffix}` +  ' Wysiwyg'}
      dangerouslySetInnerHTML={{__html: description}}
    />
  );
};

WysiwygTag.propTypes = {
  description: PropTypes.string,
  suffix: PropTypes.string,
  baseClass: PropTypes.string,
};

WysiwygTag.defaultProps = {
  description: null,
  suffix: '',
  baseClass: 'Video__wysiwyg',
};
// -----------------------------------------------
/**
 * video tag 下に敷く `img` - poster 画像
 * @param {?string} path 画像までのパス
 * @param {?string} [suffix=''] [pc|mb] 識別子
 * @param {boolean} [useYouTube=false] YouTube thumbnail use flag
 * @param {string} [baseClass=Video__video__poster] base class name
 * @returns {?ReactElement} `div.Video__video__poster-[pc|mb]` tag
 * @constructor
 */
const FigurePosterBgTag = ({ path, suffix, useYouTube, baseClass, visibleVideo }) => {
  if (!path) {
    return null;
  }
  // YouTube thumbnail は特別なクラス付与
  const ytClass = useYouTube ? `${baseClass}__youtube`: '';
  const style = {
    display: (visibleVideo && !useYouTube) ? 'none' : 'block',
    backgroundImage: `url(${path})`
  };
  return (
    <div
      className={`${baseClass} ${baseClass}${suffix ? '-': ''}${suffix} ${ytClass}`}
      style={style}
    />
  );
};


FigurePosterBgTag.propTypes = {
  path: PropTypes.string,
  suffix: PropTypes.string,
  baseClass: PropTypes.string,
  useYouTube: PropTypes.bool,
  visibleVideo: PropTypes.bool.isRequired,
};

FigurePosterBgTag.defaultProps = {
  path: null,
  suffix: '',
  baseClass: ' Video__video__poster',
  useYouTube: false,
};
// -----------------------------------------------
/**
 * `span.HeroVideo__videoFilter` filter tag を作成します
 * @param {boolean} youtube YouTube flag - true: no filter
 * @param {?boolean} filterFlag props.[pcVideoFilter|mbVideoFilter]
 * @param {string} [suffix=''] `baseClass` の末尾に追加する文字 `-` 連結します
 * @param {string} [baseClass=HeroVideo__videoFilter] コンテナへ付与する class name 先頭文字
 * @returns {?ReactElement} `span.HeroVideo__videoFilter`
 * @constructor
 */
const FilterTag = ({ youtube, filterFlag, suffix, baseClass }) => (
  (!youtube && filterFlag) ?
    <span className={`${baseClass}${(suffix) ? '-': ''}${suffix}`}/> :
    null
);

FilterTag.propTypes = {
  youtube: PropTypes.bool.isRequired,
  filterFlag: PropTypes.bool,
  suffix: PropTypes.string,
  baseClass: PropTypes.string,
};

FilterTag.defaultProps = {
  filterFlag: false,
  suffix: '',
  baseClass: 'Video__videoFilter',
};


// -----------------------------------------------
/**
 * Video component
 * - {@link RelatedVideo} modal に内蔵する
 */
export default class Video extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    pcDescription: PropTypes.string,
    mbDescription: PropTypes.string,
    youtubeId: PropTypes.string,
    pcImageSrc: PropTypes.string,
    mbImageSrc: PropTypes.string,
    videoSrc: PropTypes.string,
    size: PropTypes.string,
    autoPlay: PropTypes.bool,
    loop: PropTypes.bool,
    playOnModal: PropTypes.bool,
    videoFilter: PropTypes.bool,
    // relatedVideo: PropTypes.arrayOf(PropTypes.node),
    relatedVideo: PropTypes.array,
    backgroundColor: PropTypes.string,
    getRef: PropTypes.func,
    inFeatureCategoriesHorizontal: PropTypes.bool,
    hasBackground: PropTypes.bool,
    parentColumn: PropTypes.string,
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    pcDescription: null,
    mbDescription: null,
    youtubeId: null,
    pcImageSrc: null,
    mbImageSrc: null,
    videoSrc: null,
    size: null,
    autoPlay: null,
    loop: null,
    playOnModal: null,
    videoFilter: null,
    relatedVideo: null,
    backgroundColor: null,
    getRef: null,
    inFeatureCategoriesHorizontal: false,
    hasBackground: false,
    parentColumn: null,
  };

  /**
   * `div.RelatedVideo` が見つかるまで再帰的に parent 探索します
   * - `data-yt` から YouTube ID を取得します
   * @param {Node|HTMLElement|Element} target event target 探索起点 Node
   * @returns {?string} `data-yt` value - YouTube ID
   */
  static parseNode(target) {
    if (!target) {
      return null;
    }
    if (!target.classList || !target.classList.contains('RelatedVideo')) {
      return Video.parseNode(target.parentNode);
    }
    return target.dataset.yt;
  }

  // /**
  //  * `div.Video__wysiwyg-[pc|mb]` tag 生成します
  //  * @param {?string} description 説明文(HTML)
  //  * @param {?string} [suffix=''] [pc|mb] 識別子
  //  * @param {string} [baseClass=Video__wysiwyg] base class name
  //  * @returns {?ReactElement} `div.Video__wysiwyg-[pc|mb]` tag
  //  */
  // static wysiwygTag(description, suffix = '', baseClass = 'Video__wysiwyg') {
  //   if (!description) {
  //     return null;
  //   }
  //   return (
  //     <div
  //       className={`${baseClass}${suffix ? '-': ''}${suffix}` +  ' Wysiwyg'}
  //       dangerouslySetInnerHTML={{__html: description}}
  //     />
  //   );
  // }

  // /**
  //  * video tag 下に敷く `img` - poster 画像
  //  * @param {?string} path 画像までのパス
  //  * @param {?string} [suffix=''] [pc|mb] 識別子
  //  * @param {boolean} [useYouTube=false] YouTube thumbnail use flag
  //  * @param {string} [baseClass=Video__video__poster] base class name
  //  * @returns {?ReactElement} `div.Video__video__poster-[pc|mb]` tag
  //  */
  // static figurePosterBgTag(path, suffix = '', useYouTube = false, baseClass = ' v') {
  //   if (!path) {
  //     return null;
  //   }
  //   // YouTube thumbnail は特別なクラス付与
  //   const ytClass = useYouTube ? `${baseClass}__youtube`: '';
  //   return (
  //     <div
  //       className={`${baseClass} ${baseClass}${suffix ? '-': ''}${suffix} ${ytClass}`}
  //       style={{backgroundImage: `url(${path})`}}
  //     />
  //   );
  // }

  // /**
  //  * `span.HeroVideo__videoFilter` filter tag を作成します
  //  * @param {?boolean} filterFlag props.[pcVideoFilter|mbVideoFilter]
  //  * @param {string} [suffix=''] `baseClass` の末尾に追加する文字 `-` 連結します
  //  * @param {string} [baseClass=HeroVideo__videoFilter] コンテナへ付与する class name 先頭文字
  //  * @returns {?ReactElement} `span.HeroVideo__videoFilter`
  //  */
  // static filterTag(filterFlag, suffix = '', baseClass = 'Video__videoFilter') {
  //   if (filterFlag === null || !filterFlag) {
  //     return null;
  //   }
  //   return <span className={`${baseClass}${(suffix) ? '-': ''}${suffix}`}/>;
  // }

  constructor(props) {
    super(props);
    // if (this.props.hasBackground || (this.props.backgroundColor && this.props.backgroundColor !== '')) {
    //   console.log('hasBackground(Video) : ' + true);
    // } else {
    //   console.log('hasBackground(Video) : ' + false);
    // }
    if (this.props.getRef) this.props.getRef(this);
    /**
     * bound onClickModalOpen - modal open event handler
     * @type {bound|any}
     */
    this.onClickModalOpen = this.onClickModalOpen.bind(this);
    /**
     * bound onClickModalClose - modal close event handler
     * @type {bound|any}
     */
    this.onClickModalClose = this.onClickModalClose.bind(this);
    /**
     * bound onClickModalCloseByContent - `div.Video__modal__content` click handler
     * @type {bound|any}
     */
    this.onClickModalCloseByContent = this.onClickModalCloseByContent.bind(this);
    /**
     * bound onPcVideoEnded - PC video ended event handler
     * @type {bound|any}
     */
    this.onPcVideoEnded = this.onPcVideoEnded.bind(this);
    /**
     * bound onMbVideoEnded - MB video ended event handler
     * @type {bound|any}
     */
    this.onMbVideoEnded = this.onMbVideoEnded.bind(this);
    /**
     * YouTube iframe 参照 - mount 後設定されます
     * @type {?Element}
     */
    this.youtubeIframe = null;
    /**
     * YouTube iframe src - `postMessage` 失敗する Browser のみ失敗時に設定されます
     * @type {string}
     */
    this.youtubeIframeSrc = '';
    /**
     * HTML5 video tag
     * @type {{pc: ?Element, mb: ?Element}}
     */
    this.videos = {
      pc: null,
      mb: null,
    };
    /**
     * HTML5 video ended flag
     * @type {{pc: boolean, mb: boolean}}
     */
    this.ended = {
      pc: false,
      mb: false,
    };
    /**
     * bound onPcVideoPlay - pc.video.play event handler
     * @type {bound|any}
     */
    this.onPcVideoPlay = this.onPcVideoPlay.bind(this);
    /**
     * bound onMbVideoPlay - mb.video.play event handler
     * @type {bound|any}
     */
    this.onMbVideoPlay = this.onMbVideoPlay.bind(this);
    /**
     * play flag
     * @type {{pc: boolean, mb: boolean}}
     */
    this.playing = {
      pc: false,
      mb: false,
    };
    /**
     * poster 画像存在 flag
     * @type {{pc: boolean, mb: boolean}}
     */
    this.posters = {
      pc: false,
      mb: false,
    };
    const hasVideo = !!props.videoSrc;
    this.state = {
      // modal open / close
      isOpen: '',
      // YouTube ID
      youtubeId: '',
      visiblePc: hasVideo,
      visibleMb: hasVideo,
      playOut: '',
      showControls: !props.autoPlay,
      containerHeight: null,
    };
    /**
     * bind onClickRelated - {@link RelatedVideo} click を親 Node で delegate します
     * @type {bound|any}
     */
    this.onClickRelated = this.onClickRelated.bind(this);
    /**
     * autoPlay flag true の時に scroll / resize event 監視します
     * @type {bound|any}
     */
    this.onScroll = this.onScroll.bind(this);
    this.onResize = this.onResize.bind(this);
    /**
     * scroll 監視 flag
     * - autoPlay ON
     * - video src enabled
     * @type {boolean}
     */
    this.watchScroll = props.autoPlay && props.videoSrc;
    /**
     * `div.Video__video__block` Element - mount 後に有効になります
     * @type {?Element}
     */
    this.videoContainer = null;
    this.played = false;
    this.bodyClasses = [`modal-open`];
    // this.onClickPlayVideo = this.onClickPlayVideo.bind(this);
    /**
     * modal open 時に動画再生しているか flag - modal 閉じたら再生再開
     * @type {boolean}
     */
    this.shouldPlaying = false;
    /**
     * move flag
     * @type {boolean}
     */
    this.moveFirstFrame = false;
    this.timer = {
      firstFrame: 0,
      hitTest: 0,
      hitTestCheck: 0,
      needHidePc: 0,
      needHideMb: 0,
    };
    /**
     * {@link Video} component reference - `clientHeight` 取得します
     * @type {?*}
     */
    this.refsContent = null;
    // ---
    // this.onTouchTriggerPlayVideo = this.onTouchTriggerPlayVideo.bind(this);
    // this.touchEvents = [
    //   'touchstart',
    //   'touchmove',
    //   'touchend',
    //   'touchcancel',
    //   'click',
    // ];

    // EPIServerのプレビュー時のモーダルの位置調整
    this.wrapperScrollTop = 0;

  }

  // /**
  //  * touch event を delegate して Android で autoplay できないやつを play する
  //  */
  // onTouchTriggerPlayVideo() {
  //   const video = this.videos.mb;
  //   const playing = this.playing.mb;
  //   if (video && !playing && this.hitTest()) {
  //     // console.log('Video.onTouchTriggerPlayVideo', video.paused, playing);
  //     this.playVideo(false);
  //   }
  // }

  getContentsHeight() {
    // return this.refs.contents.clientHeight;
    return this.refsContent.clientHeight;
  }

  setContainerHeight(height) {
    if (this.state.containerHeight !== height) {
      this.setState({
        containerHeight: height,
      });
    }
    // this.setState({
    //   containerHeight: height,
    // })
  }

  clearContainerHeight() {
    if (this.state.containerHeight !== null) {
      this.setState({
        containerHeight: null,
      });
    }
    // this.setState({
    //   containerHeight: null,
    // })
  }

  // /**
  //  * click で not auto play video 再生します
  //  * @param {Event} event clck event
  //  */
  // onClickPlayVideo(event) {
  //   event.preventDefault();
  //   this.playVideo();
  //   this.setState({playOut: 'Video__btn__play__video__out'});
  // }

  /**
   * `a.Video__Youtube__link` click event handler
   * - modal open します - state.isOpen: 'is-open'
   * @param {Event} event click Event
   */
  onClickModalOpen(event) {
    event.preventDefault();
    this.executeOpen();
  }

  /**
   * `button.Video__modal__btn__close` click event handler
   * - modal 閉じます - state.isOpen: ''
   * - YouTube 再生を止めます - `postMessage('{"event":"command","func":"stopVideo","args":""}', '*')`
   * @param {Event} event click Event
   */
  onClickModalClose(event) {
    event.preventDefault();
    this.executeClose();
  }

  /**
   * `div.Video__modal__content` click handler
   * - modal 閉じます - state.isOpen: ''
   * - YouTube 再生を止めます - `postMessage('{"event":"command","func":"stopVideo","args":""}', '*')`
   * @param {Event} event click Event
   */
  onClickModalCloseByContent(event) {
    const target = event.target;
    const nodeName = target.nodeName.toLowerCase();
    // const className = target.className;
    if (nodeName === 'div' && target.classList.contains('Video__modal__content')) {
      this.executeClose();
    }
  }

  /**
   * PC: video ended event handler
   * - {@link Video.pc.ended} flag true 設定します
   * - loop 設定がない時に rewind します - video.pause() & video.currentTime = 0
   */
  onPcVideoEnded() {
    // video end
    const { pcLoop } = this.props;
    const video = this.videos.pc;
    // video element が存在し loop: false の時に rewind させる
    if (video && !pcLoop) {
      this.dispose();
      // ---
      this.ended.pc = true;
      this.played = false;
      this.pauseVideo(true);
      this.rewindVideo(true);
      // this.rewindVideos();
      this.shouldPlaying = false;
      // 背景に画像がある時のみ video 非表示
      if (this.posters.pc) {
        this.setState({ visiblePc: false });
      }
    }
  }

  /**
   * MB: video ended event handler
   * - {@link Video.mb.ended} flag true 設定します
   * - loop 設定がない時に rewind します - video.pause() & video.currentTime = 0
   */
  onMbVideoEnded() {
    // video end
    const {mbLoop} = this.props;
    const video = this.videos.mb;
    // video element が存在し loop: false の時に rewind させる
    if (video && !mbLoop) {
      this.dispose();
      // ---
      this.ended.mb = true;
      this.played = false;
      this.pauseVideo(false);
      this.rewindVideo(false);
      this.shouldPlaying = false;
      // 背景に画像がある時のみ video 非表示
      if (this.posters.mb) {
        this.setState({ visibleMb: false });
      }
    }
  }

  /**
   * pc: video.play event handler
   * - timer clear
   * - playing flag true
   */
  onPcVideoPlay() {
    // console.log('Video.onPcVideoPlay', Date.now());
    this.playing.pc = true;
  }

  /**
   * mb: video.play event handler
   * - timer clear
   * - playing flag true
   */
  onMbVideoPlay() {
    // console.log('Video.onMbVideoPlay');
    this.playing.mb = true;
    // this.disposeTouches();
  }

  /**
   * 関連動画コンテナ click event handelr
   * - parent parse し youtubeId が見つかれば - this.state.youtubeId 更新する
   * - 見つからない時は modal 閉じる
   * @param {Event} event click Event
   */
  onClickRelated(event) {
    const target = event.target;
    const youtubeId = Video.parseNode(target);
    if (youtubeId) {
      this.setState({youtubeId});
    } else {
      // close modal
      this.executeClose();
    }
  }

  // -----------------------------------------------------
  // [SCROLL / RESIZE]
  /**
   * window.onscroll|onresize event handler
   * - コンテナ `div.Video__video__block` の window 内チェックを行います - {@link Video.checkHitWithPlayOrPause} -> {@link Video.hitTest} -> {@link Video.clientRect}
   */
  onScroll() {
    this.checkHitWithPlayOrPause();
  }

  onResize() {
    this.checkHitWithPlayOrPause();
  }

  /**
   * `div.Video__video__block` の window 内チェックを行います
   * - {@link Video.hitTest} -> {@link Video.clientRect}
   * - window 内 - {@link Video.playVideos} 再生します
   * - window 外 - {@link Video.pauseVideos} 停止します
   * @param {boolean} [mountCheck=false]
   */
  checkHitWithPlayOrPause(mountCheck = false) {
    clearTimeout(this.timer.hitTestCheck);
    const hit = this.hitTest();
    if (hit === null) {
      this.timer.hitTestCheck = setTimeout(() => {
        this.checkHitWithPlayOrPause();
      }, 16);
      return;
    }
    // ---
    if (hit) {
      if (!mountCheck) {
        // console.log('Video.checkHitWithPlayOrPause - hit -> play', this.videos.pc.src, hit, this.clientRect(), window.innerHeight);
        this.playVideos();
      }
    } else {
      // console.log('Video.checkHitWithPlayOrPause - hit -> pause', this.videos.pc.src, hit, this.clientRect(), window.innerHeight);
      this.pauseVideos();
      this.rewindVideos();
    }
  }

  /**
   * `div.Video__video__block`.getBoundingClientRect 実行し clientRect 取得します
   * @returns {?ClientRect} offset 値を返します {top, width, height...}
   */
  clientRect() {
    return this.videoContainer ? this.videoContainer.getBoundingClientRect() : null;
  }

  /**
   * `div.Video__video__block` clientRect と `window.innerHeight` を比較し hit test を行います
   * @returns {?boolean} true: window 内
   */
  hitTest() {
    const clientRect = this.clientRect();
    if (!clientRect) {
      return false;
    }
    const { top, bottom, left, right } = clientRect;
    if (top === 0 && bottom === 0 && left === 0 && right === 0) {
      return null;
    }
    // clientRect.top が scroll 位置を考慮しない
    const display = {
      top: 0,
      bottom: window.innerHeight,
      left: 0,
      right: window.innerWidth,
    };
    // console.log('Video.hitTest', clientRect, display, (display.top < clientRect.bottom && display.bottom > clientRect.top), (clientRect.left >= 0 && clientRect.left < display.right), (clientRect.right <= display.right && clientRect.right >= 0));
    return ((top >= display.top && top < display.bottom) || (bottom <= display.bottom && bottom > display.top)) &&
      ((left >= 0 && left < display.right) || (right <= display.right && right > 0));
  }

  // -----------------------------------------------------
  /**
   * error message より　`video` 非表示実行します
   * - no supported source - 404, ...etc
   * - didn't interact - have to touch
   * @param {boolean} pc video file select flag - true: PC
   * @param {Error} error video play error message
   * @returns {boolean} true - 非表示実行
   */
  needHideVideo(pc, error) {
    if (!error) {
      return false;
    }
    // 404: ~ no supported source ~
    // touch first: failed because the user didn't interact with the document first
    const massages = [
      'no supported source',
      'didn\'t interact',
    ];
    const result = massages.some(message => (error.message.indexOf(message) !== -1));
    if (result) {
      const state = pc ? { visiblePc: false } : { visibleMb: false };
      // console.log('Video.needHideVideo -', result, massages, error, state);
      this.setState(state);
      return true;
    }
    return false;
  }
  /**
   * {@link Video.needHideVideo} - error message より　`video` 非表示実行します
   * - no supported source - 404, ...etc
   * - didn't interact - have to touch
   * 戻り値 `false` - 非表示にならない時は 1frame に移動して止める
   * @param {boolean} pc video file select flag - true: PC
   * @param {string} [error=''] video play error message
   */
  playFaultAlternateImage(pc, error = '') {
    // console.log('Video.playFaultAlternateImage', pc, this.posters);
    if (this.needHideVideo(pc, error)) {
      return;
    }
    this.pauseVideo(pc);
    this.rewindVideo(pc);
  }
  /**
   * HTML5 video start します
   * @param {boolean} pc video file select flag - true: PC
   */
  playVideo(pc) {
    // console.log('Video.playVideo', pc, this.played, this.ended);
    const ended = pc ? this.ended.pc : this.ended.mb;
    if (ended) {
      return;
    }
    const video = pc ? this.videos.pc : this.videos.mb;
    if (!video) {
      return;
    }
    if (!video.paused) {
      return;
    }
    let playPromise = null;
    // let success = false;
    try {
      playPromise = video.play();
      // success = true;
    } catch (e) {
      console.warn(`[VIDEO] play video fault, ${error}`, video.src);
      // success  = false;
      this.playFaultAlternateImage(pc, e);
    }
    if (playPromise) {
      playPromise.catch(error => {
        console.warn(`[VIDEO] play video fault in Promise, ${error}`, video.src);
        // success  = false;
        this.playFaultAlternateImage(pc, error);
      });
    }
  }
  /**
   * video tag play 実行します - {@link Video.playVideo}
   */
  playVideos() {
    // console.log('Video.playVideos', this.played, this.ended, this.videos.pc.src);
    this.played = true;
    this.playVideo(true);
    this.playVideo(false);
  }
  pauseVideo(pc) {
    const visible = pc ? this.state.visiblePc : this.state.visibleMb;
    if (!visible) {
      return;
    }
    const video = pc ? this.videos.pc : this.videos.mb;
    if (!video) {
      return;
    }
    // status check - 2018-10-31
    if (video.paused) {
      return;
    }
    // console.log('Video.pauseVideo - pc', pc, visible, this.ended, this.videos.pc.src);
    try {
      video.pause();
    } catch (error) {
      console.warn(`[VIDEO] pause video fault, ${error}`, pc, video.src);
    }
  }
  /**
   * video tag - pause 実行します
   */
  pauseVideos() {
    // console.log('Video.pauseVideos', this.played, this.ended, this.videos.pc.src);
    this.played = false;
    this.pauseVideo(true);
    this.pauseVideo(false);
  }
  rewindVideo(pc) {
    // ---
    // 再生中は rewind しない
    if (this.played) {
      return;
    }
    const visible = pc ? this.state.visiblePc : this.state.visibleMb;
    if (!visible) {
      return;
    }
    const video = pc ? this.videos.pc : this.videos.mb;
    if (!video) {
      return;
    }
    try {
      video.currentTime = 0;
    } catch (error) {
      console.warn(`[VIDEO] rewindVideo fault, ${error}`, pc, video.src);
    }
  }
  /**
   * rewind します
   */
  rewindVideos() {
    // console.log('Video.rewindVideos', this.played, this.ended, this.videos.pc.src);
    this.rewindVideo(true);
    this.rewindVideo(false);
  }

  // -----------------------------------------------
  // doMoveFirstFrame(delay = 32) {
  //   clearTimeout(this.timer.firstFrame);
  //   // 完全に再生が始まるのを待つ
  //   if (!this.played) {
  //     this.timer.firstFrame = setTimeout(() => {
  //       this.doMoveFirstFrame(delay);
  //     }, delay);
  //     return;
  //   }
  //   this.pauseVideos();
  //   // first frame
  //   this.rewindVideos();
  // }

  /**
   * ~~poster 画像を表示できない時のみ video 1frame へ移動します~~
   *
   * autoPlay: false -  video 1frame へ移動します
   */
  shouldFirstFrame() {
    const {
      autoPlay,
    } = this.props;
    // console.log('Video.shouldFirstFrame', autoPlay, this.videos);
    if (autoPlay) {
      return;
    }
    // video tag exist
    const { pc, mb } = this.videos;
    if (!pc && !mb) {
      return;
    }
    // ---
    this.pauseVideos();
    this.rewindVideos();
  }

  // -----------------------------------------------
  /**
   * modal 開きます
   * - modal open します - state.isOpen: 'is-open'
   * - document.body add `.un-scroll-pc`, `.un-scroll-mb`
   */
  executeOpen() {
    // modal open flag on body
    // document.body.classList.add(this.modalOpened);

    // 再生中のみ止める
    // console.log('Video.executeOpen', this.played, this.videos.pc.src);
    if (this.played) {
      this.pauseVideos();
      // 再生 flag ON
      this.shouldPlaying = true;
    }

    // EPIServerのプレビュー時のモーダルの位置調整
    // let isEpiServerPreview = false;
    if (WINDOW && WINDOW.epi && WINDOW.parent) {
      const wrapperElement = WINDOW.parent.document.querySelector("div[data-dojo-attach-point='previewContainer']");
      if (wrapperElement) {
        const wrapperHeight = wrapperElement.clientHeight;
        this.wrapperScrollTop = wrapperElement.scrollTop;
        const iframe = wrapperElement.querySelector('iframe');
        if (iframe) {
          DOCUMENT.body.style.position = 'absolute';
          DOCUMENT.body.style.top = -this.wrapperScrollTop + 'px';
          const headerElement = WINDOW.document.querySelector('header') || null;
          if (headerElement) {
            headerElement.style.zIndex = 0;
          }
          iframe.style.height = wrapperHeight + 'px';
          // isEpiServerPreview = true;
        }
      }
    }

    // if (!isEpiServerPreview) {
    //   // BODYのスクロール無効化
    //   BodyControl.openModal();
    // }

    // BODYのスクロール無効化
    BodyControl.openModal();
    //this.bodyClasses.map(className => (document.body.classList.add(className)));

    if (0 <= String(navigator.userAgent).indexOf('MyMazda')) {
      this.setState({ isOpen: 'is-open', youtubeId: this.props.youtubeId });
    } else {
      // IOS10の場合の処理
      const iosVer = (()=> {
        if ( /iP(hone|od|ad)/.test( navigator.platform ) ) {
          var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
          var versions = [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
          return versions[0];
        }
        else return 0;
      })();
      if (IS_IOS && iosVer < 11) {
        setTimeout(()=> {
          this.setState({ isOpen: 'is-open', youtubeId: this.props.youtubeId });
        }, 200)
      } else {
        this.setState({ isOpen: 'is-open', youtubeId: this.props.youtubeId });
      }
    }

    //this.setState({ isOpen: 'is-open', youtubeId: this.props.youtubeId });

  }

  /**
   * modal を閉じ YouTube 再生を止めます
   * - state.isOpen: ''
   * - {@link Video.stopYouTube}
   * - document.body remove `.un-scroll-pc`, `.un-scroll-mb`
   */
  executeClose() {
    this.stopYouTube();
    // ---
    // document.body.classList.remove(this.modalOpened);

    // 再生 flag ON の時のみ再開させる
    if (this.shouldPlaying) {
      this.playVideos();
    }

    // EPIServerのプレビュー時のモーダルの位置調整
    if (WINDOW && WINDOW.epi && WINDOW.parent) {
      const wrapperElement = WINDOW.parent.document.querySelector("div[data-dojo-attach-point='previewContainer']");
      if (wrapperElement) {
        const iframe = wrapperElement.querySelector('iframe');
        if (iframe) {
          DOCUMENT.body.style.position = 'static';
          DOCUMENT.body.style.top = 'auto';
          const headerElement = WINDOW.document.querySelector('header') || null;
          if (headerElement) {
            headerElement.style.zIndex = 3000;
          }
          iframe.style.height = DOCUMENT.body.clientHeight + 'px';
          wrapperElement.scrollTop = this.wrapperScrollTop;
        }
      }
    }

    // BODYのスクロール無効化を解除
    BodyControl.closeModal();
    //this.bodyClasses.map(className => (document.body.classList.remove(className)));

    // this.setState({ isOpen: '', youtubeId: this.props.youtubeId });
    this.setState({ isOpen: '', youtubeId: null });
  }

  /**
   * YouTube modal 閉じる時に再生を止めます
   */
  stopYouTube() {
    const player = this.youtubeIframe;
    if (!player) {
      return;
    }
    try {
      player.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
    } catch (error) {
      console.warn('Video.stopYouTube', error);
      // postMessage - 実行できないときは iframe src を空にして無理やり止める
      this.youtubeIframeSrc = player.src;
      player.src = '';
    }
  }
  /**
   * YouTube iframe src path を作成します
   * @param {string} [id=''] YouTube ID YouTube modal は必ず開くエラーになっても...
   * @returns {string} `//www.youtube.com/embed/${id}?rel=0&version=3&enablejsapi=1`
   */
  createPath(id = '') {
    const path = id ? `//www.youtube.com/embed/${id}?rel=0&version=3&enablejsapi=1&showinfo=0&modestbranding=0` : '';
    this.youtubeIframeSrc = path;
    return path;
  }

  /**
   * React 経由で無い event handler を unbind します
   */
  dispose() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onResize);
  }
  // disposeTouches() {
  //   this.touchEvents.map(type => (window.removeEventListener(type, this.onTouchTriggerPlayVideo)));
  // }
  /**
   * HTML5 video mete します
   * - attribute muted が有効にならないので property を制御します
   */
  videosToMute() {
    Object.values(this.videos).map((video) => {
      if (video) {
        video.muted = true;
        video.defaultMuted = true;
      }
      return video;
    });
  }
  afterDidUpdateHitTest() {
    clearTimeout(this.timer.hitTest);
    if (this.state.isOpen) {
      return;
    }
    const hit = this.hitTest();
    if (hit === null) {
      this.timer.hitTest = setTimeout(() => {
        this.afterDidUpdateHitTest();
      }, 16);
      return;
    }
    // console.log('Video.afterDidUpdateHitTest - check hit', this.videos.pc.src, hit, this.clientRect(), window.innerWidth);
    if (hit) {
      this.playVideos();
    }
  }
  componentDidUpdate() {
    const { pc, mb } = this.ended;
    if (!pc && !mb && this.watchScroll) {
      this.afterDidUpdateHitTest();
    }
  }
  /**
   * delegate - after mount
   * - 条件により scroll / resize 監視を行います
   */
  componentDidMount() {
    this.videosToMute();
    // console.log('Video.componentDidMount', Date.now());
    // ---
    if (this.watchScroll) {
      // 要監視
      this.dispose();
      window.addEventListener('scroll', this.onScroll, false);
      window.addEventListener('resize', this.onResize, false);
      // first check を強制的に実行します
      // console.log('Video.componentDidMount', this.videos.pc.src);
      this.checkHitWithPlayOrPause();
    } else {
      // console.log('Video.componentDidMount - shouldFirstFrame', this.watchScroll);
      this.shouldFirstFrame();
    }
    // // ---
    // // Android `NotAllowedError: play() failed because the user didn't interact with the document first.` の対策で touch 監視して再生させる
    // if (this.videos.mb && 'ontouchstart' in document.documentElement) {
    //   this.touchEvents.map(type => (window.addEventListener(type, this.onTouchTriggerPlayVideo, false)));
    // }
  }

  /**
   * delegate - before unmount
   * - timer clear する
   */
  componentWillUnmount() {
    // console.log('Video.componentWillUnmount', this.videos.pc.src);
    // this.pauseVideos();
    Object.values(this.timer).map(id => (clearTimeout(id)));
    // ---
    this.dispose();
    // this.disposeTouches();
  }

  /**
   * YouTube modal link 作成します - `a.HeroVideo__Youtube__link`
   * @returns {?Element} `a.HeroVideo__Youtube__link`
   */
  renderYouTubeLink() {
    const {
      // youtubeId,
      playOnModal,
    } = this.props;
    if (!playOnModal) {
      return null;
    }
    // modal open
    // type を className へ
    // @since 2018-10-27 - FB: #ref https://hakuhodoms.backlog.com/view/MZD_RNAL_INNER-271#comment-9355197
    // win(IE11) ・モーダルを開くと、ページTOPに移動してしまう（URLの末尾に#）
    // a to span
    return <span
      data-href="#"
      className="Video__Youtube__link"
    />;
  }

  // -----------------------------------------------
  /**
   * HTML5 video tag を作成します
   * @param {?string} src video path
   * @param {?boolean} loop loop flag
   * @param {?string} [poster=null] poster image path
   * @param {string} [suffix=''] `baseClass` の末尾に追加する文字 `-` 連結します
   * @param {string} [baseClass=Video__video] コンテナへ付与する class name 先頭文字
   * @returns {?Element} `video.Video__video` tag を返します
   */
  renderVideoTag(src, loop, poster = null, suffix = '', baseClass = 'Video__video') {
    // require check
    // console.log('Video.renderVideoTag', suffix, src, poster);
    if (src === null || !src || !suffix) {
      return null;
    }
    const { visiblePc, visibleMb } = this.state;
    // ---
    const isPc = (suffix === 'pc');
    const visible = isPc ? visiblePc : visibleMb;
    if (!visible) {
      if (isPc) {
        this.videos.pc = null;
      } else {
        this.videos.mb = null;
      }
      return null;
    }
    // ---
    // this.played = autoPlay && visiblePc && visibleMb;
    // class name
    const className = `${baseClass}${(suffix) ? '-': ''}${suffix}`;
    // video tag
    const attributes = {
      preload: 'none',
      controls: false,
      // autoPlay: false,
      autoPlay: true,
      playsInline: true,
      muted: true,
      loop: !!loop,
      src,
      className,
      type: `video/${src.split('.').pop().split('?').shift()}`,
    };
    // poster 存在する時のみ
    if (poster) {
      attributes.poster = poster;
    }
    // pc / mb
    // onEnded event と ref を分けるために分岐処理する
    // - autoPlay で play させて resize 制御しないことにする
    if (isPc) {
      attributes.ref = (component) => (this.videos.pc = component);
      attributes.onEnded = this.onPcVideoEnded;
      attributes.onPlay = this.onPcVideoPlay;
      attributes.style = (visiblePc) ? null : { display: 'none' };
      // attributes.autoPlay = visiblePc && autoPlay;
      if (!visiblePc) {
        attributes.autoPlay = null;
      }
      // attributes.preload = 'none';
    } else {
      attributes.ref = (component) => (this.videos.mb = component);
      attributes.onEnded = this.onMbVideoEnded;
      attributes.onPlay = this.onMbVideoPlay;
      attributes.style = (visibleMb) ? null: { display: 'none' };
      // attributes.autoPlay = visibleMb && autoPlay;
      if (!visibleMb) {
        attributes.autoPlay = null;
      }
      // attributes.preload = 'metadata';
    }
    // ---
    // tag
    return <video {...attributes} />;
    // return (
    //   <video {...attributes} muted={true}>
    //     <source src={src} type={`video/${src.split('.').pop().split('?').shift()}`} />
    //   </video>
    // );
  }

  /**
   * page 内表示の YouTube iframe タグを作成します
   * @returns {?HTMLIFrameElement} YouTube `iframe.Video__youtube__iframe`
   */
  renderYtPage() {
    const { youtubeId, playOnModal } = this.props;
    if (!youtubeId || playOnModal) {
      return null;
    }

    //const src = `//www.youtube.com/embed/${youtubeId}?rel=0&version=3&showinfo=0&enablejsapi=1&modestbranding=0`;
    return (
      <YoutubePlayer
        cls="Video__youtube__iframe"
        height={'100%'}
        width={'100%'}
        autoplay={0}
        controls={1}
        youtubeId={youtubeId}
        isModal={false}
      />
      // <iframe
      //   src={src}
      //   frameBorder="0"
      //   className="Video__youtube__iframe"
      //   // allow="autoplay; encrypted-media"
      //   allowFullScreen={true}
      // />
    );
  }
  /**
   * `div.Video__figure__block`
   * - video figure container を作成します
   * @returns {?Element} `div.Video__figure__block`
   */
  renderFigureVideo() {
    const {
      videoSrc,
      videoFilter,
      loop,
      pcImageSrc,
      mbImageSrc,
      youtubeId,
    } = this.props;
    // ---
    const ytThumb = youtubeId ? `//img.youtube.com/vi/${youtubeId}/maxresdefault.jpg`: '';
    //const pcPosterSrc = pcImageSrc || ytThumb;
    let pcPosterSrc = pcImageSrc || null;
    pcPosterSrc = (!pcPosterSrc && !videoSrc) ? ytThumb : pcPosterSrc;
    const mbPosterSrc = mbImageSrc || pcPosterSrc;
    // ---
    const pcVideo = this.renderVideoTag(videoSrc, loop, pcPosterSrc, 'pc');
    const mbVideo = this.renderVideoTag(videoSrc, loop, mbPosterSrc, 'mb');
    // ---
    const { visiblePc, visibleMb } = this.state;
    const pcPoster = <FigurePosterBgTag
      path={pcPosterSrc}
      suffix="pc"
      useYouTube={pcPosterSrc === ytThumb}
      visibleVideo={visiblePc}
    />;
    const mbPoster = <FigurePosterBgTag
      path={mbPosterSrc}
      suffix="mb"
      useYouTube={mbPosterSrc === ytThumb}
      visibleVideo={visibleMb}
    />;
    // const pcPoster = Video.figurePosterBgTag(pcPosterSrc, 'pc', pcPosterSrc === ytThumb);
    // const mbPoster = Video.figurePosterBgTag(mbPosterSrc, 'mb', mbPosterSrc === ytThumb);
    // ---
    // video tag 無い時のみ
    const youtube = (!pcVideo || !mbVideo) ? this.renderYtPage() : null;
    // ---
    if (!pcVideo && !mbVideo && !pcPoster && !mbPoster && !youtube) {
      return null;
    }
    // ---
    this.posters.pc = !!pcPosterSrc;
    this.posters.mb = !!mbPosterSrc;
    // ---
    // filter
    const pcFilter = <FilterTag
      youtube={!!youtube}
      filterFlag={videoFilter}
      suffix="pc"
    />;
    const mbFilter = <FilterTag
      youtube={!!youtube}
      filterFlag={videoFilter}
      suffix="mb"
    />;
    // const pcFilter = (!youtube) ? Video.filterTag(videoFilter, 'pc'): null;
    // const mbFilter = (!youtube) ? Video.filterTag(videoFilter, 'mb'): null;
    // ---
    // youtube modal trigger
    const youtubeLink = this.renderYouTubeLink();
    // ---
    // mp4 play icon
    // const playButton = this.videoPlayButton();
    // ---
    // output
    return (
      <div
        className="Video__figure__block"
        ref={component => (this.videoContainer = component)}
      >
        <div
          className="Video__video__block"
          // ref={component => (this.videoContainer = component)}
        >
          {youtube}
          {pcVideo}
          {mbVideo}
          {pcPoster}
          {mbPoster}
        </div>
        {pcFilter}
        {mbFilter}
        {youtubeLink}
      </div>
    );
  }

  /**
   * `div.Video__container > div.Video__wysiwyg` 作成します
   * @returns {?ReactElement} `div.Video__container > div.Video__wysiwyg`
   */
  renderWysiwyg() {
    const {
      pcDescription,
      mbDescription,
    } = this.props;
    const mbHtml = mbDescription || pcDescription;
    const pc = <WysiwygTag description={pcDescription} suffix="pc" />;
    const mb = <WysiwygTag description={mbHtml} suffix="mb" />;
    // const pc = Video.wysiwygTag(pcDescription, 'pc');
    // const mb = Video.wysiwygTag(mbHtml, 'mb');
    if (!pc && !mb) {
      return null;
    }
    return (
      <div className="Video__container" ref="container">
        <div className="Video__wysiwyg Wysiwyg">
          {pc}
          {mb}
        </div>
      </div>
    );
  }

  /**
   * YouTube modal 関連動画 - `div.Video__modal__relatedVideos`
   * @returns {?Element} `div.Video__modal__relatedVideos`
   */
  renderRelatedVideo() {
    const { relatedVideo } = this.props;
    if (relatedVideo === null || !Array.isArray(relatedVideo) || !relatedVideo.length) {
      return null;
    }
    if (relatedVideo.length > 6) {
      relatedVideo.length = 6;
    }
    return (
      <div
        className="RelatedVideo__container"
        role="presentation"
        onClick={this.onClickRelated}
      >
        <h2 className="RelatedVideo__main_title">関連動画</h2>
        <div className="RelatedVideo__wrap">
          {
            relatedVideo.map((component, index) => {
              const id = `video-relatedVideo-${index}`;
              return <RelatedVideo key={id} {...component.props} />;
            })
          }
        </div>
      </div>

    );
  }

  /**
   * YouTube 再生するための modal container - `div.Video__modal`
   * - 関連動画クリックで iframe src 差替えます - {@link Video.state.youtubeId} を使用します
   * - YouTube iframe API 使用する
   * - `postMessage` を使用し control します `//www.youtube.com/embed/` - `embed` 必須 not `v`
   * - `enablejsapi=1` 必須
   * - {@link Video.youtubeIframe} へ iframe 参照を保存します
   * @returns {?Element} `div.Video__modal`
   * @see https://developers.google.com/youtube/iframe_api_reference?hl=ja
   */
  renderModalYouTube() {
    const { youtubeId, isOpen } = this.state;
    const { playOnModal } = this.props;
    if (!playOnModal) {
      return null;
    }
    if (!isOpen) {
      return null;
    }
    // ---
    // unique id - control する時に識別子として必要になるかもなので念のために設定する
    const id = this.youtubeIframeId;
    // ---
    const src = this.createPath(youtubeId);
    // ---
    return (
      <div className={`Video__modal ${isOpen}`}>
        <div
          className="Video__modal__overlay"
          role="presentation"
          onClick={this.onClickModalClose}
        />
        <div
          className="Video__modal__content"
          onClick={this.onClickModalCloseByContent}
        >
          <div className="Video__modal__content__inner">
            <div className="Video__modal__movie__block">
              <YoutubePlayer
                cls="Video__modal__movie"
                height={'100%'}
                width={'100%'}
                autoplay={1}
                // autoplay={0}
                controls={1}
                youtubeId={youtubeId}
                isModal={true}
              />
              {/*<iframe*/}
              {/*id={id}*/}
              {/*src={src}*/}
              {/*frameBorder="0"*/}
              {/*className="Video__modal__movie"*/}
              {/*allow="autoplay; encrypted-media"*/}
              {/*allowFullScreen={true}*/}
              {/*ref={component => (this.youtubeIframe = component)}*/}
              {/*/>*/}
            </div>
            {this.renderRelatedVideo()}
          </div>
        </div>
        <span
          className="Video__modal__btn__close"
          onClick={this.onClickModalClose}
        />
      </div>
    );
  }

  render() {
    const {
      containerId,
      containerClass,
      size,
      playOnModal,
    } = this.props;
    // ---
    const figureVideo = this.renderFigureVideo();
    const wysiwyg = this.renderWysiwyg();
    // ---
    if (!figureVideo && !wysiwyg) {
      return null;
    }
    // ---
    const sizeClass = `size__${(size || 'Standard').toLowerCase()}`;
    // ---
    let style = {};
    if (this.props.backgroundColor) {
      style.backgroundColor = '#' + this.props.backgroundColor.replace(/#/g, '');
    }
    if (this.state.containerHeight) {
      style.height = this.state.containerHeight;
    }
    //
    let layout2 = null;
    if (this.props.hasBackground || (this.props.backgroundColor && this.props.backgroundColor !== '')) {
      layout2 = 'hasBackground';
      if (this.props.parentColumn === 'oneColumnLayout') {
        layout2 = 'hasBackground oneColumnLayout';
      } else if (this.props.parentColumn === 'twoColumnLayout') {
        layout2 = 'hasBackground twoColumnLayout';
      } else if (this.props.parentColumn === 'threeColumnLayout') {
        layout2 = 'hasBackground threeColumnLayout';
      } else if (this.props.parentColumn === 'fourColumnLayout') {
        layout2 = 'hasBackground fourColumnLayout';
      }
    }
    // ---
    return (
      <Wrapper
        containerId={containerId}
        containerClass={containerClass}
      >
        {(() => {
          if (playOnModal === true) {
            return (
              <article
                className="Video__article"
                style={(style.backgroundColor) ? {backgroundColor: style.backgroundColor}: null}
              >
                <div
                  className={`Video ${sizeClass} ${(layout2) ? layout2 : ''}`}
                  ref={(component) => (this.refsContent = component)}
                >
                  <div
                    className="Video__link"
                    style={(style.height) ? {height: style.height}: null}
                    onClick={this.onClickModalOpen}
                    data-movie={(this.props.youtubeId) ? this.props.youtubeId : ''}
                  >
                    {figureVideo}
                    {wysiwyg}
                  </div>
                  {this.renderModalYouTube()}
                </div>
              </article>
            )
          }
          return (
            <article
              className="Video__article"
              style={style}
            >
              <div
                className={`Video ${sizeClass}`}
                ref={(component) => (this.refsContent = component)}
              >
                {figureVideo}
                {wysiwyg}
                {this.renderModalYouTube()}
              </div>
            </article>
          )
        })()}
      </Wrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/video/index.jsx